// import React, { Component } from "react";
import {SessionInstanceRestService} from './restServices';
import storageService from '../storageService';

// let privateState = {}; // private variables for this service.
// let alreadyInitiated = false; // used for singletonProcess
let service = {};
service.mentorCreateSessionInstance = function (
  sessionInstanceData,
  successCallbackFunction,
  failureCallbackFunction,

  token,
) {
  //Dto = sessionTemplateId, mentorUserId, sessionStartTimeMentor
  // console.debug(
  //   "mentorCreateSessionInstance - sessionInstanceData: ",
  //   sessionInstanceData
  //   /* " mentorUserId ",mentorUserId*/
  // );
  var newSessionInstanceObject = {
    token: token ? token : storageService.getItem('token'),
    sessionInstanceDto: sessionInstanceData,
  };
  SessionInstanceRestService.save(
    {
      endpoint: 'new',
      endpointParam: null,
    },
    newSessionInstanceObject,
    function (resource) {
      console.debug(resource);
      successCallbackFunction(resource.sessionInstanceDto);
    },
    function (response) {
      console.debug(response.data);
      failureCallbackFunction && failureCallbackFunction(response);
    },
  );
};

service.clientJoinSessionInstance = function (
  sessionInstanceDto,
  successCallbackFunction,
) {
  //sessionInstanceId, clientUserId, sessionStartTimeClient, moneyTransactionId
  var sessionInstanceId = sessionInstanceDto.sessionInstanceId;
  var requestObject = {
    token: storageService.getItem('token'),
    sessionInstanceDto: sessionInstanceDto,
  };
  SessionInstanceRestService.update(
    {
      endpoint: 'clientJoin',
      endpointParam: sessionInstanceId,
    },
    requestObject,
    function (resource) {
      console.debug(resource);
      successCallbackFunction(resource.sessionInstanceDto);
    },
    function (response) {
      console.debug(response.data);
    },
  );
};

service.mentorSessionInstanceHeartBeat = function (
  sessionInstanceDto,
  successCallbackFunction,
) {
  //sessionInstanceId, mentorUserId
  var sessionInstanceId = sessionInstanceDto.sessionInstanceId;
  var requestObject = {
    token: storageService.getItem('token'),
    sessionInstanceDto: sessionInstanceDto,
  };
  SessionInstanceRestService.update(
    {
      endpoint: 'mentorHeartBeat',
      endpointParam: sessionInstanceId,
    },
    requestObject,
    function (resource) {
      console.debug(resource);
      successCallbackFunction(resource.sessionInstanceDto);
    },
    function (response) {
      console.debug(response.data);
    },
  );
};

service.clientSessionInstanceHeartBeat = function (
  sessionInstanceDto,
  successCallbackFunction,
) {
  //sessionInstanceId, clientUserId
  var sessionInstanceId = sessionInstanceDto.sessionInstanceId;
  var requestObject = {
    token: storageService.getItem('token'),
    sessionInstanceDto: sessionInstanceDto,
  };
  SessionInstanceRestService.update(
    {
      endpoint: 'clientHeartBeat',
      endpointParam: sessionInstanceId,
    },
    requestObject,
    function (resource) {
      // console.debug(resource);
      successCallbackFunction(resource.sessionInstanceDto);
    },
    function (response) {
      console.debug(response.data);
    },
  );
};

service.mentorSessionInstanceEnd = function (
  sessionInstanceDto,
  successCallbackFunction,
) {
  //sessionInstanceId, mentorUserId, sessionEndTimeMentor
  var sessionInstanceId = sessionInstanceDto.sessionInstanceId;
  var requestObject = {
    token: storageService.getItem('token'),
    sessionInstanceDto: sessionInstanceDto,
  };
  SessionInstanceRestService.update(
    {
      endpoint: 'mentorHangUp',
      endpointParam: sessionInstanceId,
    },
    requestObject,
    function (resource) {
      console.debug(resource);
      successCallbackFunction(resource.sessionInstanceDto);
    },
    function (response) {
      console.debug(response.data);
    },
  );
};

service.clientSessionInstanceEnd = function (
  sessionInstanceDto,
  successCallbackFunction,
) {
  //sessionInstanceId, clientUserId, sessionEndTimeClient
  var sessionInstanceId = sessionInstanceDto.sessionInstanceId;
  var requestObject = {
    token: storageService.getItem('token'),
    sessionInstanceDto: sessionInstanceDto,
  };
  SessionInstanceRestService.update(
    {
      endpoint: 'clientHangUp',
      endpointParam: sessionInstanceId,
    },
    requestObject,
    function (resource) {
      console.debug(resource);
      successCallbackFunction(resource.sessionInstanceDto);
    },
    function (response) {
      console.debug(response.data);
    },
  );
};

service.deleteSessionInstanceBySessionInstanceId = function (
  sessionInstanceId,
  successCallbackFunction,
) {
  var requestObject = {
    token: storageService.getItem('token'),
    sessionInstanceId: sessionInstanceId,
  };
  SessionInstanceRestService.update(
    {
      endpoint: 'delete',
      endpointParam: sessionInstanceId,
    },
    requestObject,
    function (resource) {
      console.debug(resource);
      successCallbackFunction(resource.sessionInstanceDto);
    },
    function (response) {
      console.debug(response.data);
    },
  );
};

service.deleteAllSessionInstances = function (successCallbackFunction) {
  var requestObject = {
    token: storageService.getItem('token'),
    sureToDelete: true,
  };
  SessionInstanceRestService.delete(
    {
      endpoint: 'deleteAll',
      endpointParam: '',
    },
    requestObject,
    function (resource) {
      console.debug(resource);
      successCallbackFunction(resource.sessionInstanceDto);
    },
    function (response) {
      console.debug(response.data);
    },
  );
};

service.getSessionInstanceDtoBySessionInstanceId = function (
  sessionInstanceId,
  successCallbackFunction,
) {
  var requestObject = {
    endpoint: 'sessionInstanceId',
    endpointParam: sessionInstanceId,
    token: storageService.getItem('token'),
  };
  SessionInstanceRestService.get(
    requestObject,
    function (resource) {
      // success
      console.debug(resource);
      if (successCallbackFunction) {
        successCallbackFunction(resource.sessionInstanceDto);
      } else {
        return resource.sessionInstanceDto;
      }
    },
    function (response) {
      // failure
      console.debug(response.data);
      return null;
    },
  );
};

service.getAllsessionInstanceIdsByMentorId = function (
  mentorId,
  successCallbackFunction,
) {
  var requestObject = {
    endpoint: 'mentorId',
    endpointParam: mentorId,
    token: storageService.getItem('token'),
  };

  SessionInstanceRestService.get(
    requestObject,
    function (resource) {
      // success
      console.debug(resource);
      if (successCallbackFunction) {
        successCallbackFunction(resource.sessionInstanceDto);
      } else {
        return resource.sessionInstanceDto;
      }
    },
    function (response) {
      // failure
      console.debug(response.data);
      return null;
    },
  );
};

service.getAllsessionInstanceIdsBySessionTemplateId = function (
  sessionTemplate,
  successCallbackFunction,
) {
  var requestObject = {
    endpoint: 'sessionTemplate',
    endpointParam: sessionTemplate,
    token: storageService.getItem('token'),
  };

  SessionInstanceRestService.get(
    requestObject,
    function (resource) {
      // success
      console.debug(resource);
      if (successCallbackFunction) {
        successCallbackFunction(resource.sessionTemplatesDto);
      } else {
        return resource.sessionTemplatesDto;
      }
    },
    function (response) {
      // failure
      console.debug(response.data);
      return null;
    },
  );
};

const sessionInstanceService = {...service};
export default sessionInstanceService;
